import React from 'react';

function Categories() {
  const categories = [
    {
      id: 'cakes',
      name: '精致蛋糕',
      desc: '生日、婚礼、纪念日专属定制',
      icon: (
        <svg viewBox="0 0 64 64" fill="none">
          <ellipse cx="32" cy="40" rx="28" ry="12" fill="currentColor" opacity="0.3"/>
          <path d="M8 40c0-8 6-14 12-14 4 0 8 2 10 5 2-3 6-5 10-5 6 0 12 6 12 14v4H8v-4z" fill="currentColor"/>
          <ellipse cx="32" cy="26" rx="24" ry="8" fill="currentColor" opacity="0.5"/>
          <path d="M12 26c0-6 5-10 10-10 3 0 6 1.5 8 4 2-2.5 5-4 8-4 5 0 10 4 10 10v2H12v-2z" fill="currentColor"/>
          <ellipse cx="32" cy="16" rx="18" ry="6" fill="currentColor" opacity="0.7"/>
          <path d="M18 16c0-4 4-7 7-7 2 0 4 1 6 3 2-2 4-3 6-3 3 0 7 3 7 7v2H18v-2z" fill="currentColor"/>
          <circle cx="32" cy="8" r="4" fill="currentColor"/>
        </svg>
      )
    },
    {
      id: 'pastries',
      name: '法式甜品',
      desc: '马卡龙、闪电泡芙、塔类',
      icon: (
        <svg viewBox="0 0 64 64" fill="none">
          <path d="M8 50c0-10 8-18 16-18 6 0 11 3 13 8 2-5 7-8 13-8 8 0 16 8 16 18v6H8v-6z" fill="currentColor" opacity="0.4"/>
          <path d="M12 48c0-8 7-14 14-14 5 0 9 2 11 6 2-4 6-6 11-6 7 0 14 6 14 14v4H12v-4z" fill="currentColor" opacity="0.6"/>
          <ellipse cx="32" cy="34" rx="20" ry="6" fill="currentColor"/>
          <circle cx="22" cy="32" r="3" fill="#fff" opacity="0.8"/>
          <circle cx="32" cy="30" r="3" fill="#fff" opacity="0.8"/>
          <circle cx="42" cy="32" r="3" fill="#fff" opacity="0.8"/>
        </svg>
      )
    },
    {
      id: 'gifts',
      name: '精美礼盒',
      desc: '馈赠佳礼，心意之选',
      icon: (
        <svg viewBox="0 0 64 64" fill="none">
          <rect x="10" y="24" width="44" height="32" rx="2" fill="currentColor" opacity="0.3"/>
          <path d="M32 10L26 24h12L32 10z" fill="currentColor"/>
          <rect x="28" y="24" width="8" height="32" fill="currentColor" opacity="0.5"/>
          <path d="M10 30h44M32 24v32" stroke="currentColor" strokeWidth="2"/>
          <circle cx="32" cy="40" r="4" fill="currentColor" opacity="0.6"/>
        </svg>
      )
    },
    {
      id: 'custom',
      name: '定制服务',
      desc: '专属设计，独一无二',
      icon: (
        <svg viewBox="0 0 64 64" fill="none">
          <circle cx="32" cy="32" r="24" fill="currentColor" opacity="0.2"/>
          <path d="M32 16c-2 0-3 1-3 3s1 3 3 3 3-1 3-3-1-3-3-3z" fill="currentColor"/>
          <path d="M32 26c-6 0-11 5-11 11s5 11 11 11 11-5 11-11-5-11-11-11z" fill="currentColor" opacity="0.4"/>
          <path d="M32 42c-2 0-3 1-3 3s1 3 3 3 3-1 3-3-1-3-3-3z" fill="currentColor"/>
          <circle cx="32" cy="32" r="4" fill="currentColor"/>
          <path d="M32 8v6M32 50v6M8 32h6M50 32h6" stroke="currentColor" strokeWidth="2" opacity="0.3"/>
        </svg>
      )
    }
  ];

  return (
    <section className="categories">
      <div className="container">
        <div className="section-header">
          <span className="section-label">精选分类</span>
          <h2 className="section-title">探索我们的甜蜜世界</h2>
        </div>
        <div className="categories-grid">
          {categories.map(category => (
            <div className="category-card" key={category.id} data-category={category.id}>
              <div className="category-icon">
                {category.icon}
              </div>
              <h3 className="category-name">{category.name}</h3>
              <p className="category-desc">{category.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Categories;
